import { Slide } from '@/components/core/Slide';
import audioFile from './19-challenges.mp3';

const autoNextDuration = 61000;
const transcript = `
  Laten we kijken naar de belangrijkste uitdagingen waar technische mkb-bedrijven mee worstelen.

  Het meest urgente probleem is zonder twijfel het structurele tekort aan vakmensen. Dit raakt de kern 
  van elk technisch bedrijf en beperkt de groeimogelijkheden aanzienlijk.

  Een tweede grote uitdaging is de digitale transformatie. Veel mkb-bedrijven lopen achter in digitale 
  volwassenheid. Dit is zorgwekkend omdat het direct invloed heeft op hun concurrentiekracht in de markt.

  Dan zien we ook toenemende druk door strengere duurzaamheidseisen. Dit vraagt om aanpassingen in 
  werkprocessen en materiaalgebruik. Maar het biedt tegelijkertijd ook nieuwe kansen voor bedrijven 
  die hier proactief op inspelen.

  Tot slot worden projecten steeds complexer. Goede ketensamenwerking met partners wordt daarom 
  cruciaal. Alleen door effectief samen te werken kunnen we faalkosten verminderen en projecten 
  succesvol afronden.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-3xl font-bold mb-8">⚠️ Uitdagingen MKB</h1>
        <ul className="space-y-4 list-disc">
          <li>Structureel tekort aan vakmensen</li>
          <li>Achterstand in digitale volwassenheid</li>
          <li>Toenemende duurzaamheidseisen</li>
          <li>Complexere projecten en ketensamenwerking</li>
        </ul>
      </div>
    </Slide>
  );
};
